import i18n from '../i18n'

export function yardInstructionHeaders () {
  return ([
    {
      id: 0,
      sortable: false,
      text: i18n.t('status'),
      value: 'status',
      align: 'center'
    },
    {
      id: 1,
      sortable: true,
      text: i18n.t('name'),
      value: 'name'
    },
    {
      id: 2,
      sortable: false,
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center',
      hidable: false
    }
  ])
}

export function yardInstructionCustomCells () {
  return [{
    slotName: 'status',
    value: 'status'
  },
  {
    slotName: 'name',
    value: 'name'
  },
  {
    slotName: 'actions',
    value: 'actions'
  }]
}
